import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { AppleEmoji } from '../../components/AppleEmoji';
import './AccountLayout.css';

const NAV = [
  { path: '/account', end: true, emoji: '👤', label: 'Профиль' },
  { path: '/account/verification', emoji: '🛡', label: 'Верификация' },
  { path: '/account/orders', emoji: '📦', label: 'История покупок' },
  { path: '/account/kyc', emoji: '🆔', label: 'KYC Sumsub' },
];

export default function AccountLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, token, logout, refreshUser } = useAuthStore();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate('/login', { state: { from: location.pathname } });
      return;
    }
    refreshUser();
  }, [token]);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  if (!user) {
    return (
      <div className="account-layout__loading">
        <div className="account-layout__spinner" />
      </div>
    );
  }

  return (
    <div className="account-layout">
      {sidebarOpen && <div className="account-layout__overlay" onClick={() => setSidebarOpen(false)} />}

      <aside className={`account-sidebar ${sidebarOpen ? 'account-sidebar--open' : ''}`}>
        <div className="account-sidebar__logo">
          <span>RubEx</span>
          <span className="account-sidebar__logo-sub"> change</span>
        </div>

        <button
          className="account-sidebar__back"
          onClick={() => navigate('/')}
        >
          <AppleEmoji emoji="🏠" size={18} />
          <span>На главную</span>
        </button>

        <div className="account-sidebar__user">
          <div className="account-sidebar__avatar">
            <AppleEmoji emoji="👤" size={28} />
          </div>
          <div className="account-sidebar__user-info">
            <div className="account-sidebar__user-email">{user.email || '—'}</div>
            <div className="account-sidebar__user-status">
              {user.is_fully_verified ? (
                <>
                  <AppleEmoji emoji="✓" size={12} /> Верифицирован
                </>
              ) : (
                <>
                  <AppleEmoji emoji="⏳" size={12} /> Нужна верификация
                </>
              )}
            </div>
          </div>
        </div>

        <nav className="account-sidebar__nav">
          {NAV.map((item) => {
            const needsAttention =
              item.path === '/account/verification' && !user.is_fully_verified;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.end}
                className={({ isActive }) =>
                  'account-sidebar__link' + (isActive ? ' account-sidebar__link--active' : '')
                }
              >
                <span className="account-sidebar__icon">
                  <AppleEmoji emoji={item.emoji} size={22} />
                </span>
                <span className="account-sidebar__label">{item.label}</span>
                {needsAttention && <span className="account-sidebar__dot" />}
              </NavLink>
            );
          })}

          {user.is_admin && (
            <NavLink
              to="/admin"
              className="account-sidebar__link account-sidebar__link--admin"
            >
              <span className="account-sidebar__icon">
                <AppleEmoji emoji="⚙️" size={22} />
              </span>
              <span className="account-sidebar__label">Админ-панель</span>
            </NavLink>
          )}
        </nav>

        <button
          className="account-sidebar__logout"
          onClick={() => {
            logout();
            navigate('/');
          }}
        >
          <AppleEmoji emoji="🚪" size={18} />
          <span>Выйти</span>
        </button>
      </aside>

      <main className="account-main">
        <header className="account-main__mobile-header">
          <button
            className="account-main__burger"
            onClick={() => setSidebarOpen(true)}
            aria-label="menu"
          >
            <span /><span /><span />
          </button>
          <div className="account-main__mobile-title">Личный кабинет</div>
        </header>

        <div className="account-main__content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
